import { Badge, Icon } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { FaBuilding } from "react-icons/fa";
import { HiSparkles } from "react-icons/hi2";

// t('Standard (SourceMagnet)') t('Own')

export const SourceBadge = ({ global }: { global: boolean }) => {
  const { t } = useTranslation();
  return (
    <Badge
      colorScheme={global ? "purple" : "gray"}
      display="flex"
      alignItems="center"
      gap="1"
      textTransform="none"
      borderRadius="md"
      px="2"
      fontWeight="medium"
      flexShrink={0}
    >
      <Icon as={global ? HiSparkles : FaBuilding} boxSize="3" />
      {global ? t("Standard (SourceMagnet)") : t("Own")}
    </Badge>
  );
};
